import { Toaster } from '@gitbook/spine-react';

import { useAgentDockBounds } from '../Components';

/**
 * The application's toasts, kept out of the agent's way.
 *
 * They stack in the bottom-right corner, which is exactly where the dock opens its window and where
 * the rail holds the anchored panel: a toast would land on the conversation. The dock reports where
 * the conversation is, and the toasts stack beside it instead.
 */
export function AppToaster() {
    const agentBounds = useAgentDockBounds();
    return <Toaster avoid={agentBounds} />;
}
